import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import {
  Component,
  OnInit,
  Optional,
  ElementRef,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { generateRandomIdentifier } from '../../ui.service';
import { TenderV2DTO, TenderLotV2DTO, TaskDTO } from '../../api/plyca-dtos';
import { FormConfig } from '../../components/forms/form.objects';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import * as lodash from 'lodash';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { TenderRequestedMaterialListComponent } from '../requestedMaterial/TenderRequestedMaterialList.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { finalize, tap } from 'rxjs/operators';
import { ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { UnitPricesListComponent } from '../unitPrices/UnitPricesList.component';

@Component({
  selector: 'tenderEditor-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class TenderEditorComponent extends BaseFormComponent<TenderV2DTO, TenderV2DTO> implements OnInit, AfterContentInit, OnDestroy {

  project: any;
  identifier: string;
  windowHash: any;
  private validateTender = false;
  private readOnly = false;
  private cliente: string;

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public helpService: HelpService,
    private plycaErrorHandler: PlycaErrorHandler,
    private appConfig: AppConfiguration,
    @Optional() public dialogConfig: DynamicDialogConfig,
    @Optional() public ref: DynamicDialogRef,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super(elem);
    this.cliente = this.appConfig.getValue('cliente');

    // activatedRoute.params.subscribe(params => {
    //   this.identifier = params['id'];
    // });
    if (dialogConfig && dialogConfig.data) {

      this.identifier = dialogConfig.data.id;
      // PARAMETROS PARA USO DE LA INVOCACION A NEW EN MODO ALTA
      this.project = dialogConfig.data.project;
      this.task = dialogConfig.data.task;
      this.validateTender = dialogConfig.data.invalid;
      this.readOnly = dialogConfig.data.readOnly;
      // this.tender = dialogConfig['tender'];
    }
  }

  ngOnDestroy(): void {
    this.dialogService = null;
    this.dialogConfig = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  getObjectParams(): { [param: string]: string | string[] } {
    return {
    };
  }

  ngAfterContentInit(): void {
    this.windowHash = generateRandomIdentifier();
  }

  getFormSettingURL(): string {
    return 'tenderInterfaceSettings.json';
  }

  getServiceURL(): string {
    return this.configuration.TENDER_SERVICE_V2_URL;
  }

  getObjectIdentifier(): string {
    if (this.identifier !== undefined) {
      return this.identifier;
    } else {
      return 'new?projectIdentifier=' + this.project.identifier;
    }
  }

  dtoToModel(dto: TenderV2DTO): Observable<TenderV2DTO> {
    console.log('dtoToModel: ESTABLECIENDO PROJECT EN TENDER')
    dto['project'] = this.project;
    if (this.project?.breakdownLot?.lots) {
      this.project.breakdownLot.lots.forEach(tLots => {
        // se añade una propiedad a cada lote para mostrarse en el combo de lotes.
        tLots['dropdownLabel'] = tLots.lotNumber + ' - ' + tLots.description;
      });
    }
    if (dto.division !== undefined && dto.division.project !== undefined
      && dto.division.project.type === undefined && this.project !== undefined) {
      dto.division.project.type = this.project.type;
    }
    if (this.task) {
      // se clona la configuracion para no modificarla con el interface
      dto['context'] = lodash.cloneDeep(this.task.work.context);
      dto['taskData'] = lodash.cloneDeep(this.task.taskData);
      // dto['ui'] = new Object();
      // dto['ui']['listaLotes'] = this.getListaLotes();
      dto.task = {} as TaskDTO;
      dto.task.identifier = this.task.identifier;
    }
    return of(dto);
  }

  modelToDTO(model: TenderV2DTO): TenderV2DTO {
    model['project'] = undefined;
    model['ui'] = undefined;
    model['context'] = undefined;
    model['taskData'] = undefined;
    model.validationResult = undefined;
    model = JSON.parse(
      JSON.stringify(model, (k, v) => (k === '_parent' ? undefined : v))
    );
    // eliminar datos que no se persisten en el servicio de ofertas para aligerar datos enviados por red
    model.document = undefined;
    model.tenderEnvelopeDocuments = undefined;
    return model;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    return headerInfo;
  }

  initHeaderActions() {
    if (this.appConfig.getValue('requested.material.management')) {
      this.subscribe(this.headerActionsService
        .addWindowAction(
          'ProcurementProject.requestedMaterial.title',
          'fas fa-pencil-alt',
          'btn-primary',
          true,
          this.windowHash,
          this.model.orderNumber !== undefined

        ),
        () => {

          this.openMaterialEditor(this.model)

        });

    }

    if ('AYMAD' === this.cliente
      && this?.task?.work?.context?.configurations?.tenderUnitPriceActive?.value === true) {

      this.subscribe(this.headerActionsService
        .addWindowAction(
          'Precios unitarios',
          undefined,
          'btn-primary',
          this.model.orderNumber !== undefined,
          this.windowHash,
          true
        ),
        () => {

          this.openUnitPricesEditor(this.model)

        });


    }

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.save',
        'fas fa-save',
        'btn-primary',
        true,
        this.windowHash
      ),
      () => {
        this.waitService.startWaiting();
        this.subscribe(this.saveContext(false, undefined, this.model.identifier ? 'UpdateEdition' : 'InsertEdition').pipe(
          tap((savedTender: TenderV2DTO) => {
            if (savedTender.validationResult?.result === ResultTypeDTO.ERROR) {
              this.manageActionError(savedTender.validationResult);
              this.subscribe(this.dtoToModel(savedTender).pipe(
                tap((savedModel: TenderV2DTO) => this.formService.merge(this.model, savedModel))
              ))
            } else {
              // la ventana llamante cancelara la espera
              this.ref.close(true);
            }
          }),
          finalize(() => this.waitService.cancelWaiting())
        ));
      });
    if (this.validateTender) {
      this.subscribe(this.validate(false, this.model));
    }
  }

  setPYME(model: any) {
    if (model == null) {
      model = {};
    }
    if (model.tendererParty == null) {
      model.tendererParty = {};
    }
    model.tendererParty.isSmallOrMediumSizedEnterprise = undefined;

    if (model?.tendererParty?.company?.customFields?.EMP_ES_PYME_STD) {
      if (model.tendererParty.company.customFields.EMP_ES_PYME_STD.identifier === '1<>nulo') {
        model.tendererParty.isSmallOrMediumSizedEnterprise = true;
      } else if (model.tendererParty.company.customFields.EMP_ES_PYME_STD.identifier === '2<>nulo') {
        model.tendererParty.isSmallOrMediumSizedEnterprise = false;
      }
    }
    if (model?.tendererParty?.company?.email) {
      model.tendererParty.contactEMail = model.tendererParty.company.email;
    } else {
      model.tendererParty.contactEMail = undefined;
    }
    if (model?.tendererParty?.company?.temporaryConsortium !== undefined) {
      model.tendererParty.isTemporaryGroupingOfOperators = model.tendererParty.company.temporaryConsortium;
    } else {
      model.tendererParty.isTemporaryGroupingOfOperators = undefined;
    }
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.readonly = this.readOnly;
    formConfig.searchTags = [HelpType.DATA_TENDER];
    formConfig.isModalWindow = true;
    this.windowHash = generateRandomIdentifier();
    formConfig.windowHash = this.windowHash;
    formConfig.functions.push({
      identifier: 'addLot',
      fn: this.addLot.bind(this)
    });
    formConfig.functions.push({
      identifier: 'setPYME',
      fn: this.setPYME
    });
    return of(formConfig);
  }

  modalError(error) {
    this.ref.close(false);
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }

  openLotsSelector() {
    let config: DynamicDialogConfig = {
      header: 'Edición de oferta',
      width: '80%',
      style: { overflow: 'scroll', 'max-height': '90vh', 'min-height': '90vh' },
      styleClass: 'searchStyle'
    };
    // config['origen'] = doc;
    if (document) {
      // config['id'] = document.identifier;
    }
    config['tender'] = document;
    config['task'] = this.task;
    return this.dialogService.open(TenderEditorComponent, config);
  }

  addLot() {
    console.log('addLot called')
    return new TenderLotV2DTO();
  }

  openUnitPricesEditor(tender?: TenderV2DTO) {
    let config: DynamicDialogConfig = {
      header: 'Edición de precios unitarios',
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    context['readonly'] = this.readOnly;
    context['tender'] = tender;
    config['context'] = context;
    config.data = {
      task: this.task
    };

    this.modalOpened = true;
    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(UnitPricesListComponent, config).onClose,
      (materialSaved: boolean) => {
        this.modalOpened = false;
        // this.reloadAndValidate(tenderSaved);
      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);
        this.modalOpened = false;
      });
  }
  openMaterialEditor(tender?: TenderV2DTO) {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('TenderInfo.actions.editMaterial'),
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    context['readonly'] = this.readOnly;
    context['tender'] = tender;
    config['context'] = context;
    config.data = {
      task: this.task
    };

    this.modalOpened = true;
    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(TenderRequestedMaterialListComponent, config).onClose,
      (materialSaved: boolean) => {
        this.modalOpened = false;
        // this.reloadAndValidate(tenderSaved);
      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);
        this.modalOpened = false;
      });
  }

}
